import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import Loader from 'src/components/Loader';
import { Trans } from 'react-i18next';
import { makeJobUrl } from 'src/routes/routes';
import { useData } from './hooks';
import s from '../Dashboards.styles';

export const JobsSummaryDashboardWidget = () => {
  const { getJobsSummary, jobsSummary, jobsSummaryLoading, countries, countriesLoading } = useData();
  const [ queryDateRange, setQueryDateRange ] = useState({ from: null, to: null });
  const [ countryIds, setCountryIds ] = useState([]);

  const countryCountPair = jobsSummary.volumesByCountryOrRegion || [];
  const countryGroup1 = countryCountPair.filter((p,i) => i % 2 === 0);
  const countryGroup2 = countryCountPair.filter((p,i) => i % 2 === 1);


  useEffect(() => {
    getJobsSummary({ variables: { startDate: queryDateRange.from, endDate: queryDateRange.to, countryIds } });
  }, [queryDateRange.from, queryDateRange.to, countryIds, countryIds.length]);

  return (
    <Fragment>
      <s.DashboardComponent>
        <s.DashboardComponentTitle widget>
          <Trans>JOBS_SUMMARY_DASHBOARD</Trans>
        </s.DashboardComponentTitle>

        {jobsSummaryLoading ? (
          <Loader />
        ) : (
          <s.JobsSummaryDiv>
            <s.JobsSummaryInfoDiv>
              <s.JobsSummaryInfoTitle>
                Open
              </s.JobsSummaryInfoTitle>
              <s.JobsSummaryInfoBigNumber red>
                {`${jobsSummary.openJobsCount || '0'} ${jobsSummary.openJobsCount === 1 ? 'job' : 'jobs'}`}
              </s.JobsSummaryInfoBigNumber>
            </s.JobsSummaryInfoDiv>
            <s.JobsSummaryInfoDiv>
              <s.JobsSummaryInfoTitle>
                Staff Utilization Rates
              </s.JobsSummaryInfoTitle>
              <s.JobsSummaryInfoBigNumber>
                {`${jobsSummary.staffUtilizationCount || '0'} / ${jobsSummary.staffUtilizationTotal ? jobsSummary.staffUtilizationTotal : '∞'}`}
              </s.JobsSummaryInfoBigNumber>
            </s.JobsSummaryInfoDiv>
            <s.JobsSummaryInfoDiv flex2>
              <s.JobsSummaryInfoTitle>
                Volumes By Country / Region
              </s.JobsSummaryInfoTitle>
              <s.JobsSummaryCountriesDiv>
                <s.JobsSummaryCountriesColumn>
                  {countryGroup1.map((pair)=>{
                    return <s.JobsSummaryCountryRecord key={+pair.countryId}>
                      <s.JobsSummaryCountryRecordLeft>
                        {pair.name}
                      </s.JobsSummaryCountryRecordLeft>
                      <s.JobsSummaryCountryRecordRight>
                        {pair.count}
                      </s.JobsSummaryCountryRecordRight>
                    </s.JobsSummaryCountryRecord>;
                  })}
                </s.JobsSummaryCountriesColumn>
                <s.JobsSummaryCountriesColumn>
                  {countryGroup2.map((pair)=>{
                    return <s.JobsSummaryCountryRecord key={+pair.countryId}>
                      <s.JobsSummaryCountryRecordLeft>
                        {pair.name}
                      </s.JobsSummaryCountryRecordLeft>
                      <s.JobsSummaryCountryRecordRight>
                        {pair.count}
                      </s.JobsSummaryCountryRecordRight>
                    </s.JobsSummaryCountryRecord>;
                  })}
                </s.JobsSummaryCountriesColumn>
              </s.JobsSummaryCountriesDiv>
            </s.JobsSummaryInfoDiv>
            <s.JobsSummaryInfoDiv>
              <s.JobsSummaryInfoTitle>
                Late Reports
              </s.JobsSummaryInfoTitle>
              {jobsSummary.lateReports && jobsSummary.lateReports.map(r => {
                return <s.JobsSummaryLastReportRecord key={r.job.id}>
                  <s.JobsSummaryLastReportRecordLeft to={makeJobUrl(r.job.id)}>
                    {r.job.reportNumber}
                  </s.JobsSummaryLastReportRecordLeft>
                  <s.JobsSummaryLastReportRecordRight>
                    {`${r.days}d`}
                  </s.JobsSummaryLastReportRecordRight>
                </s.JobsSummaryLastReportRecord>;
              })}
            </s.JobsSummaryInfoDiv>
          </s.JobsSummaryDiv>
        )}
      </s.DashboardComponent>
    </Fragment>
  );
};

export default React.memo(JobsSummaryDashboardWidget);
